import { FC } from 'react';
import { IGeneralInfo } from '@modules/products/domain/models/productDetail.model';
import DetailInformation from '@components/product/informationGeneral/listInformation/DetailInformation';
import { Border, ContentInformation } from './GeneralInformation.style';
interface Props {
  data: IGeneralInfo;
}
const GeneralInformation: FC<Props> = ({
  data
}: Props) => {
  const {
    brand,
    brandLogo,
    category,
    weight,
    amount,
    meatType,
    allergen,
    lifeBeforeOpen,
    lifeAfterOpen,
    fdaNumber
  } = data;
  return <>
            <ContentInformation>
                <DetailInformation brand={brand} brandLogo={brandLogo} category={category} weight={weight} amount={amount} meatType={meatType} allergen={allergen} beforeOpen={lifeBeforeOpen} afterOpen={lifeAfterOpen} FDAnumber={fdaNumber} />
            </ContentInformation>
            <Border />
        </>;
};
export default GeneralInformation;